import { useRef, useEffect } from 'react'
import { toast } from "react-toastify";
import { AES, enc } from "crypto-ts";

const SECRET_KEY = '634f18644d-5989-9776-c56D2-7890bc4565763c9876';

export const isLoggedIn = (): boolean => {
  return getToken() ? true : false
}

export const usePrevious = (value: any) => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export const setToken = (token: string,isRemember?:boolean, type?: string ) => {
  let ency = AES.encrypt(token, SECRET_KEY);
  if(type == "forgotPassword"){
    sessionStorage.setItem('jwt_forgot_password_access_token', ency.toString())
  } else if(!isRemember){
    sessionStorage.setItem('jwt_access_token_pg', ency.toString());
  }else{
    localStorage.setItem('jwt_access_token_pg', ency.toString());
  }
 
}

export const getToken = (type?: string) => {
  let token = sessionStorage.getItem('jwt_access_token_pg');
  token = token?token:localStorage.getItem('jwt_access_token_pg');
  if(type == "forgotPassword") token = sessionStorage.getItem('jwt_forgot_password_access_token');
  if (token) {
    let decy: any = '';
    try {
      decy = AES.decrypt(token, SECRET_KEY);
      decy = decy.toString(enc.Utf8);
      return decy;

    } catch (err) {
      localStorage.clear()
      sessionStorage.clear()
      return decy;
    }
  }
  return "";
}

export const setEncryptedUser = (user: any) => {
  let ency = AES.encrypt(JSON.stringify(user), SECRET_KEY);
  localStorage.setItem('jwt_user_pg', ency.toString());
}

export const getDecryptedUser = () => {
  let user = localStorage.getItem('jwt_user_pg');
  if (user) {
    let decy: any = '';
    try {
      decy = AES.decrypt(user, SECRET_KEY);
      decy = decy.toString(enc.Utf8);
      return JSON.parse(decy);

    } catch (err) {
      return null;
    }
  }
  return null;
}

export const showMessage = (message: string) => {
  if (message) {
    toast(message)
  }
}

export const getTypeConfig = (type: any) => {
  switch (type) {
    case 'currency':
      return {
        type: "currency",
        useFromStore: "currency",
        bindLabel: "currency_short",
        bindValue: "currency_name",
        withIcon: true,
      };
    case 'numerical':
      return { type: 'number', withIcon: true, }
    case 'date':
      return { type: 'date', withIcon: true, }
    case 'single Line Text Field':
      return { type: 'text', withIcon: true, }
    case 'multiple line Text Field':
      return { type: 'multiLineInput', withIcon: true, }
    case 'image Upload':
      return { type: 'image', withIcon: true, }
    case 'video Upload':
      return { type: 'video', withIcon: true, }
    // case 'currency':
    //   return { type: 'text', withIcon: true, }
    // case 'measurement':
    //   return { type: 'text', withIcon: true, }
    case 'measurement':
      return {
        type: "measurement",
        useFromStore: "measurement",
        bindLabel: "unit_short",
        bindValue: "unit_name",
        withIcon: true,
      };
    case 'drop Down Development Type':
      return {
        type: 'select',
        useFromStore: 'developmentType',
        bindLabel: 'development_type',
        bindValue: 'd_type_id',
        withIcon: true,
      }
    case 'drop down property type':
      return {
        type: 'select',
        useFromExisting:'typeOfDevelopment',
        withIcon: true,
      }
    // case 'residential Type':
    //   return {
    //     type: 'select',
    //     useFromStore: 'residentialType',
    //     bindLabel: 'green_type',
    //     bindValue: 'rs_type_id',
    //     withIcon: true,
    //   }
    case 'residential Type':
      return {
        type: 'select',
        useFromExisting:'typeOfDevelopment',
        withIcon: true,
      }
    case 'percentage':
      return {
        type: 'text',
        withIcon: true,
      }
    case 'address':
      return {
        type: 'textarea',
        withIcon: true,
      }
    case 'yes/No':
      return {
        type: 'select',
        useFromExisting:'yesNo',
        withIcon: true,
      }
    case 'green Dropdown':
      return {
        type: 'select',
        useFromStore: 'greenType',
        bindLabel: 'green_type',
        bindValue: 'g_type_id',
        withIcon: true,
      }
    case 'eligibility Y/N':
      return {
        type: 'select',
        useFromExisting:'yesNo',
        withIcon: true,
      }
    case 'submitted Info':

      return {
        type: 'submitterForm',
        withIcon: true,
      }
    case 'custom Answer List':
      return {
        type: 'input', withIcon: true,
      }
    case 'checkbox':
      return {
        type: 'boxCheckBox',
        withIcon: true,
      }
    
    default:
      return {type:'text'}
  }
}


export function isValidDate(d:any) {
  return !isNaN(d) && d instanceof Date ;
}

export const logout = () => {
  localStorage.clear()
  sessionStorage.clear()
  let w: any = window;
  w.location = '/'
}

export const parseJwt = (token: any) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};